import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  Dispatch,
  SetStateAction
} from 'react';
import { SplitHandlers } from './hooks';
import { SplitEntryFormData } from './splitNoteSchema';

type SplitEntryContextValue = SplitHandlers & {
  splitEntries: SplitEntryFormData[];
  labelLoading?: boolean;
  showStartEndTime: boolean;
  isFormError: boolean;
  setIsFormError: Dispatch<SetStateAction<boolean>>;
};

export const SplitEntriesContext = createContext<
  SplitEntryContextValue | undefined
>(undefined);

export const useSplitEntriesContext = (): SplitEntryContextValue => {
  const value = useContext(SplitEntriesContext);
  if (!value) {
    throw Error('should be called in SplitEntryContextProvider scope');
  }
  return value;
};

type SplitEntryContextProviderProps = SplitHandlers & {
  splitEntries: SplitEntryFormData[];
  labelLoading?: boolean;
  showStartEndTime?: boolean;
  children?: React.ReactNode;
};
export const SplitEntryContextProvider: React.FC<SplitEntryContextProviderProps> = ({
  children,
  labelLoading = false,
  showStartEndTime = false,
  ...rest
}: SplitEntryContextProviderProps) => {
  const [isFormError, setIsFormError] = useState(false);

  const value = useMemo(
    () => ({
      labelLoading,
      showStartEndTime,
      isFormError,
      setIsFormError,
      ...rest
    }),
    [labelLoading, showStartEndTime, isFormError, rest]
  );

  return (
    <SplitEntriesContext.Provider value={value}>
      {children}
    </SplitEntriesContext.Provider>
  );
};
